import DaiLyPage from "./DaiLyPage";

export default DaiLyPage